import React from "react"
import autobind from "class-autobind"
import { IUIUser, IPunchBundle, IPunchResult, EPunchValidationType, ITimecardEmployee } from "../../../models"
import { IconButton } from "material-ui"
import GlobalPunchEditIcon from "../../../../assets/icons/global-punch-edit"
import strings from "../../../localization/strings"
import * as permissionHelper from "../../../helpers/permissionHelper"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import * as punchActions from "../../../actions/PunchActions"
import AppStateStore from "../../../stores/AppStateStore"
import PunchResultDialog from "../punch_result/PunchResultDialog"
import GlobalPunchEditDrawer from "./GlobalPunchEditDrawer"
interface IProps {
    style?: React.CSSProperties
    dayStartTime24Hour: number
    startDate: string | Date
    endDate: string | Date
    globalPunchEmployees: ITimecardEmployee[]
    reloadPage?(): void
}
interface IState {
    openGlobalPunchEditDrawer: boolean
    editResults: IPunchResult[]
}

export default class GlobalPunchEdit extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            openGlobalPunchEditDrawer: false,
            editResults: []
        }
        autobind(this)
    }

    handleEditGlobalPunches(punchBundles: IPunchBundle[]) {
        this.setState({ openGlobalPunchEditDrawer: false })
        AppStateStore.setProgressSnackbarContent("loading")
        punchActions.editGlobalPunch(punchBundles).then((editResults: IPunchResult[]) => {
            this.setState({ editResults })
            AppStateStore.setProgressSnackbarContent(null)
        })
    }

    render() {
        if (!permissionHelper.hasPermission(AuthenticationStore.Permissions.Timecards.GlobalPunchEdit)) return null
        return (
            <div style={this.props.style}>
                <IconButton
                    data-intercom-target={"Timecards-Btn-GlobalEditPunch"}
                    tooltip={strings.Global_Punch_Edit}
                    iconStyle={{ width: 22, height: 22 }}
                    style={{ padding: 0, top: 2, height: 40 }}
                    onTouchTap={() => this.setState({ openGlobalPunchEditDrawer: true })}
                >
                    <GlobalPunchEditIcon width={20} height={20} />
                </IconButton>
                <GlobalPunchEditDrawer
                    open={this.state.openGlobalPunchEditDrawer}
                    dayStartTime24Hour={this.props.dayStartTime24Hour}
                    globalPunchEmployees={this.props.globalPunchEmployees as IUIUser[]}
                    startDate={this.props.startDate}
                    endDate={this.props.endDate}
                    handleClose={() => this.setState({ openGlobalPunchEditDrawer: false })}
                    handleEditGlobalPunches={this.handleEditGlobalPunches}
                />
                <PunchResultDialog
                    isGlobalPunch
                    globalPunchEmployees={this.props.globalPunchEmployees}
                    results={this.state.editResults}
                    handleClose={() => {
                        this.props.reloadPage && this.state.editResults.filter(i => i.Type === EPunchValidationType.Valid).length &&
                            this.props.reloadPage()
                        this.setState({ editResults: [] })
                    }}
                />
            </div>
        )
    }
}
